import { render } from "./ProjectionView.vue?vue&type=template&id=771eca49&scoped=true"
import script from "./ProjectionView.vue?vue&type=script&lang=js"
export * from "./ProjectionView.vue?vue&type=script&lang=js"

import "./ProjectionView.vue?vue&type=style&index=0&id=771eca49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771eca49"]])

export default __exports__